// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"project-single_wrapper__WTDPm"};